import { memo } from 'react';
import ReactQuill, { Quill } from 'react-quill-new';

import type { Parchment } from 'quill';
import { isNonNullish } from 'remeda';

import { formats, modules } from './constants';

import css from './RichTextarea.module.css';
import 'react-quill-new/dist/quill.snow.css';

const SizeStyle = Quill.import('attributors/style/size') as Parchment.StyleAttributor;
SizeStyle.whitelist = ['12px', '14px', '16px', '18px', '20px', '22px', '24px'];

Quill.register(Quill.import('attributors/style/align') as Parchment.RegistryDefinition, true);
Quill.register(SizeStyle, true);

interface RichTextareaProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

export const RichTextarea = memo<RichTextareaProps>(({ label, value, onChange, required }) => (
  <div>
    {isNonNullish(label) && (
      <p className={css.reachTextareaTitle}>
        {label} {required && '*'}
      </p>
    )}

    <ReactQuill
      className={css.reachTextarea}
      theme="snow"
      value={value}
      onChange={onChange}
      modules={modules}
      formats={formats}
    />
  </div>
));

RichTextarea.displayName = 'RichTextarea';
